import {Component}                            from '@angular/core';
import {CaffRecordLogIntf, CaffRecordSumIntf} from '@djsharkk/logr-types';
import {MenuCrudPanelContentBase}             from '../../menu-crud-panel-content-base';
import {MenuCrudPanelBotComponent}            from '../menu-crud-panel-bot.component';

@Component({
			   selector   : 'app-menu-crud-panel-caff-bot',
			   imports    : [
				   MenuCrudPanelBotComponent
			   ],
			   templateUrl: './menu-crud-panel-caff-bot.component.html',
			   styleUrl   : './menu-crud-panel-caff-bot.component.css'
		   })
export class MenuCrudPanelCaffBotComponent extends MenuCrudPanelContentBase<CaffRecordLogIntf, CaffRecordSumIntf> {


	constructor() {
		super('caff', false);

	}
}
